import Flag from "../../assets/icons/Flag";
import { SeverityScore } from "../forms/inputs/SeverityScoreSelector";

export const getVulnerabilityColour = (severity: SeverityScore) => {
  if (!severity.category) {
    return "ctb-red-200";
  }
  switch (severity.category.toUpperCase()) {
    case "LOW":
      return "ctb-green-200 bg-ctb-green-50";
    case "MEDIUM":
      return "ctb-yellow-200 bg-yellow-50";
    case "HIGH":
      return "ctb-red-200 bg-orange-100";
    case "CRITICAL":
      return "ctb-red-500 bg-ctb-red-50";
    case "INFO":
    case "NONE":
      return "text-blue-600 bg-blue-50";
    case "DRAFT":
      return "text-slate-600 bg-slate-50";
    default:
      return "text-gray-500 bg-gray-100";
  }
};

export const getSeverityColourWithBg = (severity: SeverityScore) => {
  if (!severity.category) {
    return "text-ctb-red-200 bg-ctb-red-50";
  }
  switch (severity.category.toUpperCase()) {
    case "LOW":
      return "text-emerald-700 bg-emerald-50 border-emerald-200";
    case "MEDIUM":
      return "text-amber-700 bg-amber-50 border-amber-200";
    case "HIGH":
      return "text-orange-700 bg-orange-50 border-orange-200";
    case "CRITICAL":
      return "text-red-700 bg-red-50 border-red-200";
    case "INFO":
    case "NONE":
      return "text-blue-700 bg-blue-50 border-blue-200";
    case "DRAFT":
      return "text-slate-700 bg-slate-50 border-slate-200";
    default:
      return "text-gray-700 bg-gray-50 border-gray-200";
  }
};

const VulnerabilityFlag = ({
  label,
  className,
  flagClassName
}: {
  label: string;
  className?: string;
  flagClassName?: string;
}) => {
  // Get severity color based on label
  const getSeverityColor = (label: string) => {
    switch (label.toUpperCase()) {
      case "LOW":
        return "text-emerald-700 bg-emerald-50 border-emerald-200";
      case "MEDIUM":
        return "text-amber-700 bg-amber-50 border-amber-200";
      case "HIGH":
        return "text-orange-700 bg-orange-50 border-orange-200";
      case "CRITICAL":
        return "text-red-700 bg-red-50 border-red-200";
      case "INFO":
      case "NONE":
        return "text-blue-700 bg-blue-50 border-blue-200";
      case "DRAFT":
        return "text-slate-700 bg-slate-50 border-slate-200";
      default:
        return "text-gray-700 bg-gray-50 border-gray-200";
    }
  };

  const severityColor = getSeverityColor(label);
  const displayLabel = label.toUpperCase() === "NONE" ? "Info" : label;

  return (
    <div
      className={`inline-flex items-center gap-1.5 rounded-lg border px-2.5 py-1.5 shadow-sm ${severityColor} ${className || ""
        }`}
    >
      <div className="flex items-center gap-1.5">
        <Flag className={`h-4 w-4 ${flagClassName || ""}`} />
        <span className="text-sm font-medium capitalize tracking-wide">
          {displayLabel}
        </span>
      </div>
    </div>
  );
};

export default VulnerabilityFlag;
